import { APIError, APIResponse, IAction } from '../types';

import {
  MARKETPLACE_PRODUCT_REQUEST,
  MARKETPLACE_PRODUCT_SUCCESS,
  MARKETPLACE_PRODUCT_FAILURE,
  MARKETPLACE_PRODUCT_LIST_REQUEST,
  MARKETPLACE_PRODUCT_LIST_SUCCESS,
  MARKETPLACE_PRODUCT_LIST_FAILURE,
  MARKETPLACE_MTRACK_CONSENT_DATA_REQUEST,
  MARKETPLACE_MTRACK_CONSENT_DATA_SUCCESS,
  MARKETPLACE_MTRACK_CONSENT_DATA_FAILURE,
} from './marketplace-constants';

/* GET Product Details */

export type ProductRequestAction = {
  type: string;
  payload: {
    id: string;
  };
};

export const marketplaceProductRequest = (id: string): ProductRequestAction => ({
  type: MARKETPLACE_PRODUCT_REQUEST,
  payload: { id },
});

export const marketplaceProductSuccess = (response: APIResponse): { type: string; payload: APIResponse } => ({
  type: MARKETPLACE_PRODUCT_SUCCESS,
  payload: response,
});

export const marketplaceProductFailure = (error: APIError): { type: string; response: APIError } => ({
  type: MARKETPLACE_PRODUCT_FAILURE,
  response: error,
});

/* GET Product List */

export type ProductListRequestAction = {
  type: string;
  payload: {};
};

export const marketplaceProductListRequest = (): ProductListRequestAction => ({
  type: MARKETPLACE_PRODUCT_LIST_REQUEST,
  payload: {},
});

export const marketplaceProductListSuccess = (response: APIResponse): { type: string; payload: APIResponse } => ({
  type: MARKETPLACE_PRODUCT_LIST_SUCCESS,
  payload: response,
});

export const marketplaceProductListFailure = (error: APIError): { type: string; response: APIError } => ({
  type: MARKETPLACE_PRODUCT_LIST_FAILURE,
  response: error,
});

/* GET MTrack Consent Data */

export type MTrackConsentDataRequestAction = {
  type: string;
  payload: {};
};

export const marketplaceMTrackConsentDataRequest = (): MTrackConsentDataRequestAction => ({
  type: MARKETPLACE_MTRACK_CONSENT_DATA_REQUEST,
  payload: {},
});

export const marketplaceMTrackConsentDataSuccess = (response: APIResponse): { type: string; payload: APIResponse } => ({
  type: MARKETPLACE_MTRACK_CONSENT_DATA_SUCCESS,
  payload: response,
});

export const marketplaceMTrackConsentDataFailure = (error: APIError): IAction<APIError> => ({
  type: MARKETPLACE_MTRACK_CONSENT_DATA_FAILURE,
  payload: error,
});
